import React from "react";
import moment from "moment";
import { FormGroup, ControlLabel, Input, HelpBlock } from "components/bootstrap";
import { TimeUnitInput } from "components/common";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import NumberUtils from "util/NumberUtils";
import ValidationErrors from "./ValidationErrors";
const TIME_UNITS = ["HOURS", "MINUTES", "SECONDS"];
const AbsoluteThresholdForm = ({ config, handleConfigFieldChange, validation }) => {
  const executeEvery = extractDurationAndUnit(
    moment.duration(config.execute_every_seconds, "seconds").asMilliseconds(),
    TIME_UNITS
  );
  const handleExecuteEveryChange = (nextValue, nextUnit) => {
    const seconds = moment.duration(nextValue, nextUnit.toLowerCase()).asSeconds();
    handleConfigFieldChange("execute_every_seconds", seconds.toString());
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(FormGroup, { validationState: validation.errors.threshold ? "error" : null }, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "threshold",
      name: "threshold",
      label: "Absolute Threshold (GiB)",
      type: "number",
      min: 0,
      step: 0.01,
      value: NumberUtils.bytesToGiB(config.threshold),
      help: "License usage in GiB before alert is triggered (e.g. 0.25 for 256 MiB)",
      onChange: (e) => handleConfigFieldChange("threshold", String(NumberUtils.giBToBytes(Number(e.target.value)))),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(ValidationErrors, { errors: validation.errors.threshold })), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, null, "Time Range Mode"), /* @__PURE__ */ React.createElement(HelpBlock, null, /* @__PURE__ */ React.createElement("strong", null, "Billing Period Based"), " - Absolute threshold event definitions accumulate license usage for the current billing period. Usage resets at the start of each new billing period.")), /* @__PURE__ */ React.createElement(FormGroup, { validationState: validation.errors.execute_every_seconds ? "error" : null }, /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label: "Execute Every",
      update: handleExecuteEveryChange,
      value: executeEvery.duration,
      unit: executeEvery.unit,
      units: TIME_UNITS,
      help: "How often to check license usage",
      required: true
    }
  ), /* @__PURE__ */ React.createElement(ValidationErrors, { errors: validation.errors.execute_every_seconds })));
};
export default AbsoluteThresholdForm;
